import { defineStore } from 'pinia'

export const useAppUpgradeStore = defineStore('appUpgradeStore', {
  state: () => ({
    updateRequired: false,
    forceUpdate: false,
    message: '',
    latestVersion: '',
    minimumVersion: '',
    dismissed: false
  }),
  getters: {
    showSoftUpgrade(state) {
      return state.updateRequired && !state.forceUpdate && !state.dismissed
    },
    showHardUpgrade(state) {
      return state.forceUpdate
    },
    isBlocking(state) {
      return state.forceUpdate
    }
  },
  actions: {
    setUpgradeInfo({ update_required, force_update, message, latest_version, minimum_version }) {
      this.updateRequired = !!update_required
      this.forceUpdate = !!force_update
      this.message = message || ''
      this.latestVersion = latest_version || ''
      this.minimumVersion = minimum_version || ''
      if (force_update) {
        this.dismissed = false
      }
    },
    dismissSoftUpgrade() {
      if (!this.forceUpdate) {
        this.dismissed = true
      }
    },
    reset() {
      this.updateRequired = false
      this.forceUpdate = false
      this.message = ''
      this.latestVersion = ''
      this.minimumVersion = ''
      this.dismissed = false
    }
  }
})
